export { DemoModal, type DemoModalProps } from './demo-modal';

